module.exports = __webpack_public_path__ + "img/60.status_toilet_paper.cbb2230d.svg";